import React from "react";

const EmailIcon = ({ fillColor }: { fillColor: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24">
    <path
      fill={fillColor}
      fillRule="evenodd"
      d="M4 3C2.348 3 1 4.348 1 6v12c0 1.652 1.348 3 3 3h16c1.652 0 3-1.348 3-3V6c0-1.652-1.348-3-3-3H4Zm-.893 2.554C3.272 5.227 3.612 5 4 5h16c.388 0 .728.227.893.554L12 11.779 3.107 5.554ZM3 7.92V18c0 .548.452 1 1 1h16c.548 0 1-.452 1-1V7.92l-8.427 5.9a1 1 0 0 1-1.146 0L3 7.92Z"
      clipRule="evenodd"
    />
  </svg>
);

export default EmailIcon;
